import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from '@carvana/showroom-spinner';
import BackLink from '../future-packages/back-link/BackLink';
import {
  MyCarsContentWrapper,
  SetUpAutopayWrapper,
  SpinnerWrapper,
} from './SetUpAutopay.styles';
import SetUpAutopayCard from './set-up-autopay-card/SetUpAutopayCard';
import MyCarsRefreshHook from '../../utils/MyCarsRefreshHook';
import { useDualEventTracking } from '../../utils/useDualEventTracking';

const SetUpAutopay = () => {
  const { id: vehicleId }: any = useParams();
  const { trackEvent } = useDualEventTracking();
  useEffect(() => trackEvent('Autopay Screen'), []);

  // Refresh Hook - Avoid selectors/ redux state access before the refresh hook and loader
  const isLoading = MyCarsRefreshHook(vehicleId);
  if (isLoading) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }

  return (
    <SetUpAutopayWrapper>
      <MyCarsContentWrapper>
        <BackLink
          backLinkTrackEvent="auto_pay_cancel_button_tap"
          backLinkText="Back to Loan Details"
          backLinkRoute={`/loan-detail/${vehicleId}`}
        />
        <SetUpAutopayCard vehicleId={vehicleId} />
      </MyCarsContentWrapper>
    </SetUpAutopayWrapper>
  );
};

export default SetUpAutopay;
